import ApiService from "@/core/services/api.service";
// action types
export const GET_UNAPPROCED_REASON = "getUnapprocedReason";

// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "unapproced_reason"
  },
  getters: {},
  actions: {
    [GET_UNAPPROCED_REASON](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    }
  },
  mutations: {}
};